import { InviewAnim } from './animationClass'

export const animations = {
	fadeIn: (el: Element) => {
		const from = { autoAlpha: 0 }
		const to = [
			{ 
				autoAlpha: 1,
				duration: .3,
				ease: 'linear',
				at: .0,
			 }
		]

		const settings = {}
		
		return new InviewAnim(el, from, to, settings)
	},
	
	// fadeInUpOld: (el: Element) => {
	// 	const from = { autoAlpha: 0, y: '1rem' },
	// 		to = { autoAlpha: 1, y: 0 },
	// 		duration = .9,
	// 		ease = 'expo.out'
		
	// 	return new InviewAnim(el, from, to, {duration, ease})
	// },
	
	fadeInUp: (el: Element) => {
		const from = { autoAlpha: 0, y: '3rem' }
		const to = [
			{
				y: 0,
				duration: .75,
				ease: 'power4.out',
				at: 0,
			},
			{
				autoAlpha: 1,
				duration: .3,
				ease: 'linear',
				at: .0,
			},
		]

		const settings = {}

		return new InviewAnim(el, from, to, settings)
	},
	
	fadeInUpX2: (el: Element) => {
		const from = { autoAlpha: 0, y: '6rem' }
		const to = [
			{
				y: 0,
				duration: .75,
				ease: 'power4.out',
				at: 0,
			},
			{
				autoAlpha: 1,
				duration: .3,
				ease: 'linear',
				at: .0,
			},
		]

		const settings = {}

		return new InviewAnim(el, from, to, settings)
	},

	splitLines: (el: Element) => {
		const splitText = new SplitText(el as any, { 
		type: 'lines',
		linesClass: 'text__line'
		})
		const from = { autoAlpha: 0, y: '1.5rem' },
			to = { autoAlpha: 1, y: 0, stagger: 0.045 },
			duration = .6,
			ease = 'expo.out'

		return new InviewAnim(splitText.lines, from, to, {duration, ease})
	},
}

